import React, { useState, useEffect } from "react";

const Tab = ({ tabs, onTabChange }) => {
  const [activeTab, setActiveTab] = useState("");

  useEffect(() => {
    if (tabs && tabs.length > 0 && !activeTab) {
      setActiveTab(tabs[0].label);
      onTabChange(tabs[0].label); // Ensure the initial tab change is triggered
    }
  }, [tabs, onTabChange, activeTab]);

  const handleTabClick = (label) => {
    setActiveTab(label);
    onTabChange(label);
  };

  if (!tabs || tabs.length === 0) {
    return null; // Render nothing if tabs are empty or undefined
  }

  return (
    <div>
      <div className="flex ">
        {tabs.map((tab) => (
          <button
            key={tab.label}
            onClick={() => handleTabClick(tab.label)}
            className={`px-4 py-2 text-sm font-medium ${activeTab === tab.label ? "border-b-2 border-primary text-primary" : "text-text"}`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div className="mt-4">
        {tabs.map(
          (tab) =>
            activeTab === tab.label && <div key={tab.label}>{tab.content}</div>
        )}
      </div>
    </div>
  );
};

export default Tab;
